import { AppConfigService } from '../app-config/app-config.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Catalog } from '../../models/catalog-dto';
import { Injectable } from '@angular/core';
import { map, Observable, tap } from 'rxjs';

@Injectable({
  	providedIn: 'root'
})

export class HttpGetCatalogService {

    public readonly URL: string;

	constructor(
		private http: HttpClient,
        private configSvc: AppConfigService
	) {
        this.URL = this.configSvc.settings.apiUrl + 'v1alpha/catalog/query';
    }

	public obtain$(): Observable<Catalog[]> {

		const body = {
			"@context": {
				"@vocab": "https://w3id.org/edc/v0.0.1/ns/"
			},
			"@type": "QuerySpec"
		};

		const headers = new HttpHeaders({
			'x-api-key': this.configSvc.settings.catalogAPIKey,
			'Content-Type': 'application/json'
		});

		return this.http.post<Catalog[] | Catalog>(
			this.URL,
			body,
			{ headers }
		).pipe(
			tap((response: Catalog[] | Catalog) => {
				console.log('[HttpGetCatalogService] URL:', this.URL);
				console.log('[HttpGetCatalogService] raw response:', response);
				console.log('[HttpGetCatalogService] JSON:', JSON.stringify(response, null, 2));
			}),
			map((response: Catalog[] | Catalog) => {
				return Array.isArray(response) ? response : [response];
			})
		);

	}

}